export default __webpack_public_path__ + "static/media/maxine_detail7.b01fe0e0.jpg";